import classNames from 'classnames/bind';

import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';

import { UpgradePlanPill } from 'components/UpgradePlanPill/UpgradePlanPill';

import { PricingPlanLabelLink } from './Link';
import styles from './PricingPlanLabel.module.scss';

const c = classNames.bind(styles);

export type PricingPlanLabelProps = {
  className?: string;
  nodePlan?: string;
  hasLink?: boolean;
  placement?: 'default' | 'inline' | 'top-right';
};

export function PricingPlanLabel({
  className,
  hasLink,
  nodePlan,
  placement = 'default',
}: PricingPlanLabelProps) {
  const { data: currentPlan } = useCurrentPlan();

  // If the node plan is the same as the current plan, don't show the label
  if (currentPlan && nodePlan && currentPlan.name === nodePlan) {
    return null;
  }

  // If the node plan is not provided or is not the same as the current plan, show the label
  return (
    <PricingPlanLabelLink
      hasLink={hasLink}
      className={c(className, {
        'top-right': placement === 'top-right',
        inline: placement === 'inline',
      })}
    >
      <UpgradePlanPill
        className={c({
          'pricing-plan-label': placement !== 'inline',
        })}
      />
    </PricingPlanLabelLink>
  );
}
